// extracted by css-extract-rspack-plugin
export default {"xl-3":"Content__xl-3--n4Qrw","xl-4":"Content__xl-4--s5NBD"};